var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUltraRareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.761719 7.09337L5.75899 3.09555C5.80391 3.05962 5.85973 3.04004 5.91725 3.04004H8.49603C8.67476 3.04004 8.79729 3.22014 8.73167 3.38639L7.26839 7.09337M0.761719 7.09337L9.88172 17.6067M0.761719 7.09337H4.01505M19.0017 7.09337L14.0044 3.09555C13.9595 3.05962 13.9037 3.04004 13.8462 3.04004H11.9717C11.8591 3.04004 11.76 3.11435 11.7285 3.22244L10.9896 5.75577C10.9423 5.91791 11.0639 6.08004 11.2328 6.08004H12.7317C12.9277 6.08004 13.0495 6.29311 12.95 6.46199L12.5779 7.09337M19.0017 7.09337L9.88172 17.6067M19.0017 7.09337H15.7898M9.88172 17.6067L4.01505 7.09337M9.88172 17.6067L15.7898 7.09337M7.26839 7.09337L6.87002 8.00529C6.79691 8.17265 6.91954 8.36004 7.10217 8.36004H8.81558C8.9745 8.36004 9.09417 8.50466 9.06444 8.66077L8.33753 12.477C8.28606 12.7472 8.64157 12.8943 8.79601 12.6667L12.5779 7.09337M7.26839 7.09337H4.01505M12.5779 7.09337H15.7898",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52 3.54662C1.18597 3.38727 0.91629 3.12065 0.76 2.78662C0.600645 3.12065 0.334032 3.39033 0 3.54662C0.334032 3.70598 0.60371 3.97259 0.76 4.30662C0.919355 3.97259 1.18597 3.70598 1.52 3.54662Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7344 16.5938C16.788 16.1423 16.0239 15.3869 15.5811 14.4404C15.1296 15.3869 14.3742 16.1509 13.4277 16.5938C14.3742 17.0453 15.1382 17.8007 15.5811 18.7471C16.0326 17.8007 16.788 17.0453 17.7344 16.5938Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4804 0.886667C17.0907 0.700753 16.776 0.389704 16.5937 0C16.4078 0.389704 16.0967 0.704328 15.707 0.886667C16.0967 1.07258 16.4114 1.38363 16.5937 1.77333C16.7796 1.38363 17.0907 1.07258 17.4804 0.886667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltraRareWhite);
export default __webpack_public_path__ + "static/media/UltraRareWhite.aad7279907b90323db8076d1d9b39c73.svg";
export { ForwardRef as ReactComponent };